var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCodePromo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#25262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.912 15.291C25.448 12.754 29.567 12.754 32.104 15.291C34.641 17.827 34.641 21.946 32.104 24.483C29.567 27.02 25.448 27.02 22.912 24.483C20.375 21.946 20.375 17.827 22.912 15.291ZM24.909 17.543C23.668 18.916 23.71 21.039 25.033 22.362C26.399 23.728 28.617 23.728 29.983 22.362C31.349 20.996 31.349 18.778 29.983 17.412C28.617 16.046 26.399 16.046 25.033 17.412L24.909 17.543Z",
    fill: "#E7E7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5649 22.709C22.5649 22.709 16.8509 28.422 14.4329 30.841C13.8469 31.426 13.8469 32.376 14.4329 32.962L14.4339 32.963C15.0189 33.548 15.9679 33.548 16.5529 32.963C18.9699 30.546 24.6859 24.83 24.6859 24.83L22.5649 22.709V22.709Z",
    fill: "#E7E7E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5609 27.833L16.0259 31.369C16.0259 31.369 18.0869 33.43 19.0619 34.405C19.3379 34.681 19.7849 34.681 20.0609 34.405C20.7339 33.732 21.9249 32.541 22.5979 31.868C22.8729 31.592 22.8729 31.145 22.5979 30.869C21.6229 29.895 19.5609 27.833 19.5609 27.833V27.833Z",
    fill: "#E7E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCodePromo);
export default __webpack_public_path__ + "static/media/icon_code_promo.d5c2d83a7945deb43b6758a90565eb08.svg";
export { ForwardRef as ReactComponent };